let dataConfig;
/**
 * If a store helper is called before the store is initialized, display a
 * generic toast to the user and throw a more specific error for error
 * reporting. Log a stack trace so the developer can find the source of the
 * error.
 */

const dataConfigNotInitialized = methodName => {
  // eslint-disable-next-line no-console
  console.trace();
  return Error(`initDataConfig must be called before "${methodName}" can be used in utils.`);
};

const getDataConfig = methodName => {
  if (!dataConfig) throw dataConfigNotInitialized(methodName);
  return dataConfig;
};
/**
 * Configures data-related functions that have different implementations between
 * frontend and backend for use in utils.
 *
 * - Frontend: Called in `app/initApp`
 * - Backend: Called in `onInitCb` which is called in each function wrapper
 */

const initDataConfig = ({
  dbGroupSet,
  decryptData,
  encryptData,
  getValueOnce
}) => {
  dataConfig = {
    dbGroupSet,
    decryptData,
    encryptData,
    getValueOnce
  };
};

export { getDataConfig, initDataConfig };
